import React from 'react';
import { Music, MessageCircle, ArrowRight, Check, Play } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const TiktokPage = () => {
  const { login } = useAuth();

  const features = [
    'Automatize DMs do TikTok',
    'Responda comentários automaticamente',
    'Capture leads de vídeos virais',
    'Chatbot com IA 24/7',
  ];

  const useCases = [
    { title: 'Lead Capture', desc: 'Capture leads de vídeos virais' },
    { title: 'Comments Auto', desc: 'Responda comentários automaticamente' },
    { title: 'DM Automation', desc: 'Chatbot nas mensagens diretas' },
    { title: 'Vendas', desc: 'Converta seguidores em clientes' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        {/* Hero */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-gray-900 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Music className="h-4 w-4" />
                TikTok
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Automatize seu <span className="text-[#00f2ea]">TikTok</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Capture leads de vídeos virais e responda mensagens automaticamente no TikTok.
              </p>
              <div className="flex flex-wrap gap-4">
                <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                  Começar gratuitamente
                </Button>
                <Button variant="outline" size="lg">
                  Ver demonstração
                </Button>
              </div>
            </div>
            <div className="bg-gradient-to-br from-[#00f2ea] to-[#ff0050] rounded-3xl p-8 text-white">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <Play className="h-6 w-6 text-gray-900" />
                </div>
                <div>
                  <p className="font-semibold">ChatAlfa Bot</p>
                  <p className="text-sm opacity-80">TikTok DM</p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="bg-white/20 backdrop-blur rounded-xl p-3">
                  <p className="text-sm">Ei! Vi que você curtiu o vídeo 🎵</p>
                </div>
                <div className="bg-white text-gray-900 rounded-xl p-3 ml-8">
                  <p className="text-sm">Quero saber mais sobre o produto!</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              Recursos do TikTok
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Use Cases */}
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              Casos de uso populares
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {useCases.map((uc) => (
                <Card key={uc.title} className="hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">
                    <h3 className="font-semibold text-gray-900 mb-2">{uc.title}</h3>
                    <p className="text-sm text-gray-600">{uc.desc}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Pronto para automatizar seu TikTok?</h2>
                <p className="text-blue-100 mb-6">Comece gratuitamente em minutos</p>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TiktokPage;
